import { render } from "./PlanTreatmentTemplateDatatableFormDiagnoses.vue?vue&type=template&id=4c821d5a"
import script from "./PlanTreatmentTemplateDatatableFormDiagnoses.vue?vue&type=script&lang=js"
export * from "./PlanTreatmentTemplateDatatableFormDiagnoses.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__